<template>
  <el-dialog v-el-drag-dialog append-to-body custom-class="" :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('Payment.contactPerson')" width="400px" @close="cancel">
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form :inline="true" label-width="90px" label-position="left" @submit.native.prevent>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('Payment.contactPerson')">
            <el-input v-model="contact.contactPerson" :disabled="true" style="width: 200px" no="1" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Role')">
            <el-input v-model="contact.role" :disabled="true" style="width: 200px" no="2" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Tel')">
            <el-input v-model="contact.telephone" :disabled="true" style="width: 200px" no="3" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Mobile')">
            <el-input v-model="contact.mobile" :disabled="true" style="width: 200px" no="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Fax')">
            <el-input v-model="contact.fax" :disabled="true" style="width: 200px" no="5" />
          </el-form-item>
          <el-form-item :label="$t('Partners.emailAddress2')">
            <el-input v-model="contact.email" :disabled="true" style="width: 200px" no="6" />
          </el-form-item>
          <el-form-item :label="$t('Payment.remarks')">
            <el-input v-model="contact.remarks" type="textarea" :rows="5" :disabled="true" style="width: 200px" no="7" />
          </el-form-item>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'CargoContactsInfoDialog',
  components: {},
  props: {
    visible: { type: Boolean, required: true },
    customerId: { type: Number, required: true },
    customerContact: { type: String, required: true } // 联系人名称
  },
  data() {
    return {
      innerVisible: this.visible,
      contact: {
        contactPerson: '',
        role: '',
        telephone: '',
        mobile: '',
        email: '',
        remarks: ''
      }
    }
  },
  computed: {
  },
  created() {
    this.loadCustomer()
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    async loadCustomer() {
      let company = { cmpIdx: this.customerId }
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts) {
        for (const contact of contacts) {
          if (contact.contactPerson === this.customerContact) {
            this.contact = contact
            break
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>
